import {
  type TYachtSetupField,
  type TYachtSetupFields,
} from "../yachtSetup.types";
import { getDefaultValuesFromFields } from "../yachtSetup.utils";

export const mapGmdssSetup = (response: any) => {
  return (
    response?.data?.content?.data?.data?.gmdss ??
    getDefaultValuesFromFields(gmdssSetupFields)
  );
};
// NOTE THAT FIELDS ARE GENERATED DYNAMICALLY FROM API AND USER CLICKS, THIS IS DATA FOR BLUEPRINT
export const gmdssSetupFields: TYachtSetupFields = [
  { line: true, label: "EPIRB" },
  { name: "batser1", label: "EPIRB Serial Number" },
  { name: "batexp1", label: "EPIRB Battery Expiration" },
  { button: true, label: "Add EPIRB", type: "batexp1" },
  { line: true, label: "SART" },
  { name: "batser2", label: "SART Serial Number" },
  { name: "batexp2", label: "SART Battery Expiration" },
  { button: true, label: "Add SART", type: "batexp2" },
  { line: true, label: "VHF" },
  { name: "batser3", label: "VHF Serial Number" },
  { name: "batexp3", label: "VHF Battery Expiration" },
  { button: true, label: "Add VHF", type: "batexp3" },
  { line: true, label: "" },
  { name: "owner", label: "Owner" },
  { name: "sbm", label: "SBM" },
];
export const getNextFieldName = (str: string): string => {
  const capitalCharRegex = /([A-Z])(?!.*[A-Z])/;
  const capitalCharRegexMatch = str.match(capitalCharRegex);
  if (!capitalCharRegexMatch) return str + "A";
  else
    return str.replace(capitalCharRegex, char => {
      return String.fromCharCode(char.charCodeAt(0) + 1);
    });
};

export const getNextFieldLabel = (lastField: TYachtSetupField) => {
  if (!lastField.label) return "";
  const number = lastField.label.match(/\d+/);
  if (!number) return lastField.label + " 1";
  else
    return lastField.label.replace(/\d+/, (parseInt(number[0]) + 1).toString());
};

export const groupAndOrderDataByNumber = (
  data: Record<string, any>,
): Record<string, any[]> => {
  const groupedData: Record<string, any[]> = {};

  // Group data by number
  Object.keys(data).forEach(key => {
    const match = key.match(/\d+/);
    if (match) {
      const number = match[0];
      if (!groupedData[number]) {
        groupedData[number] = [];
      }
      groupedData[number].push({ [key]: data[key] });
    }
  });

  // Order grouped data based on gmdssSetupFields
  const orderedData: Record<string, any[]> = {};
  gmdssSetupFields.forEach(field => {
    if (field.name) {
      const match = field.name.match(/\d+/);
      if (match) {
        const number = match[0];
        if (groupedData[number]) {
          orderedData[number] = groupedData[number];
        }
      }
    }
  });

  return orderedData;
};
